"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionalLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = require("classnames");
const react_1 = require("react");
const ConditionalLink = ({ className, children, link, isNotClickable, onClick, linkTabIndex, linkAriaLabel, }) => {
    const hasLink = (0, react_1.useMemo)(() => link && link.url && link.url.length, [link]);
    const target = (0, react_1.useMemo)(() => (link && link.newWindow ? '_blank' : '_self'), [link]);
    const rel = (0, react_1.useMemo)(() => (target === '_blank' ? 'noopener' : ''), [target]);
    const handleLinkClick = (0, react_1.useCallback)((ev) => {
        if (!onClick) {
            return;
        }
        onClick(link, ev);
    }, [link, onClick]);
    if (!hasLink || isNotClickable) {
        return (0, jsx_runtime_1.jsx)("div", { className: className, children: children });
    }
    return ((0, jsx_runtime_1.jsx)("a", { href: link.url, target: target, rel: rel, className: (0, classnames_1.default)(className, { clickable: !isNotClickable }), tabIndex: linkTabIndex, "aria-label": linkAriaLabel, onClick: handleLinkClick, children: children }));
};
exports.ConditionalLink = ConditionalLink;
